export default "__VITE_ASSET__DjhnvYPB__"